module.exports = __webpack_public_path__ + "img/icon-back-solid.5184f35e.svg";